import { FormProvider, useForm } from "react-hook-form";
import PropTypes from "prop-types";

const Form = ({
    onSubmit,
    defaultValues = {},
    mode = "onBlur",
    children,
    ...rest
}) => {
    const methods = useForm({
        defaultValues,
        mode,
    });

    return (
        <FormProvider {...methods}>
            <form
                noValidate
                {...rest}
                onSubmit={methods.handleSubmit(onSubmit)}
                onReset={() => {
                    methods.reset();
                }}
            >
                {children}
            </form>
        </FormProvider>
    );
};

Form.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    defaultValues: PropTypes.object,
    mode: PropTypes.string,
    children: PropTypes.node,
};

export default Form;
